// Libs
import React from 'react';
import styled from 'styled-components';

// Components
import { TableDocumentList } from '@ibinder/common-frontend';

// Styling
/* Offsetting some parent and component behaviour */
const Wrapper = styled.main`
  border-top: 1px solid ${(p) => p.theme.colors.discrete60};
  margin: 0 -1rem;
  padding: 0 1rem;
`;

const InspectionTypeTable = ({
  headers,
  queryData,
  selectedIds,
  setSelectedIds,
  selectItem,
  selectItems,
  groupCheckStatus,
  sortBy,
  onSort,
  groupBy
}) => {
  const tableSettings = {
    headers,
    documentQuery: queryData,
    sortBy: [sortBy],
    groupBy,
    hasSelectBox: true,
    metadataElements: headers,
    selectedIds,
    setSelectedIds,
    selectItem,
    selectItems,
    groupCheckStatus,
    onSort
  };

  return (
    <Wrapper>
      <TableDocumentList
        {...{
          ...tableSettings
        }}
      />
    </Wrapper>
  );
};

export default InspectionTypeTable;
